import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ButtonComponent } from '@shared/components/button/button.component';
import { ButtonConfig } from '@shared/models/button.model';
import { BreadcrumbsComponent } from '@features/home/components/breadcrumbs/breadcrumbs.component';

@Component({
  selector: 'srm-dashboard-header',
  imports: [BreadcrumbsComponent, ButtonComponent],
  templateUrl: './dashboard-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dashboard-header.component.scss',
})
export class DashboardHeaderComponent {
  @Input({ required: true }) public pageTitle!: string;
  @Input() public pageSubtitle: string | null = null;
  @Input() public buttonConfig: ButtonConfig | null = null;
  @Input() public secondaryButtonConfig: ButtonConfig | null = null;

  @Output() public headerButtonClick = new EventEmitter<void>();
  @Output() public secondaryHeaderButtonClick = new EventEmitter<void>();

  public onButtonClick(): void {
    this.headerButtonClick.emit();
  }

  public onSecondaryButtonClick(): void {
    this.secondaryHeaderButtonClick.emit();
  }
}
